import {
  connectAutoComplete,
  connectStateResults,
} from 'react-instantsearch-dom'
import Autocomplete from './Autocomplete'

export default connectAutoComplete(connectStateResults(Autocomplete))
